import { Fraction } from 'bi-fraction';
export const calcTokenBPriceOfTokenA = (input, output, lpInfo) => {
    let r0 = lpInfo.reserve0;
    let r1 = lpInfo.reserve1;
    if (lpInfo.token0.toLowerCase() === output.address.toLowerCase()) {
        [r0, r1] = [r1, r0];
    }
    return new Fraction(r1).shr(output.decimals).div(r0).shl(input.decimals);
};
